import {permissoes, routesNames} from '@/core/constants'
import AdesaoView from '@/views/pages/adesao/AdesaoView.vue'
import AdesaoAderenteView from '@/views/pages/adesao/aderente/AdesaoAderenteView.vue'
import AdesaoItensView from '@/views/pages/adesao/aderente/itens/AdesaoItensView.vue'
import AdesaoDocumentosView from '@/views/pages/adesao/aderente/documentos/AdesaoDocumentosView.vue'
import ProcessoDigitalAdesao from '@/views/routers/routes/adesao/processo-digital/processo-digital-adesao'
import LinhaDoTempoAdesao from '@/views/pages/adesao/aderente/linha-do-tempo/LinhaDoTempoAdesao.vue'
import OcorrenciasAdesao from '@/views/pages/adesao/aderente/ocorrencias/OcorrenciasAdesao.vue'

export default [
	{
		name: routesNames.ADESAO.ADESAO_VIEW,
		path: '/adesao/:id',
		component: AdesaoView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Adesão',
			},
			requiresAuth: true,
			authorities: [permissoes.ataMenu], // alterar isso depois
		},
		children: [
			{
				name: routesNames.ADESAO.ADERENTE.ADESAO_VIEW,
				path: 'aderir/:tipoAcesso',
				component: AdesaoAderenteView,
				redirect: (to) => {
					return { name: routesNames.ADESAO.ADERENTE.ADESAO_ITENS, params: to.params }
				},
				meta: {
					page: {
						title: 'Ata',
						subtitle: 'Adesão',
						showAutoSave: true,
					},
					requiresAuth: true,
					authorities: [permissoes.ataAdesaoEditar],
				},
				children: [
					{
						meta: {
							page: {
								title: 'Adesão',
								subtitle: 'Itens',
								showAutoSave: true,
							}
						},
						name: routesNames.ADESAO.ADERENTE.ADESAO_ITENS,
						path: 'itens',
						component: AdesaoItensView,
					},
					{
						meta: {
							page: {
								title: 'Adesão',
								subtitle: 'Documentos',
							}
						},
						name: routesNames.ADESAO.ADERENTE.ADESAO_DOCUMENTOS,
						path: 'documentos',
						component: AdesaoDocumentosView,
					},
					{
						meta: {
							page: {
								title: 'Adesão',
								subtitle: 'Ocorrências',
							},
						},
						name: routesNames.ADESAO.ACESSAR_OCORRENCIAS_VIEW,
						path: 'ocorrencias',
						component: OcorrenciasAdesao,
					},
					{
						meta: {
							page: {
								title: 'Adesão',
								subtitle: 'Linha do Tempo',
							},
						},
						name: routesNames.ADESAO.ACESSAR_LINHA_DO_TEMPO_VIEW,
						path: 'linha-do-tempo',
						component: LinhaDoTempoAdesao,
					},
				],
			},
		],
	},
	...ProcessoDigitalAdesao
]
